/*
 * Input Pin
 */

// LE BUT EST D'AVOIR UN MÊME COMPOSANT EN:
//  - Vue
//  - Razor (server side TagHelper)
//  - Vanilla Js

/// 1. create from JS:
//const node = builder.component('p-dropdown', { placeholer: '' }); // create like razor taghelper + attachDropdown(node)

const attachInputPin = (node) => {
  const inputs = Array.from(node.querySelectorAll(".a-inputtext"));
  const inputPin = node.querySelector('[name="' + node.dataset.name + '"]');

  const selectNextInput = (index) => {
    if (index + 1 < inputs.length) {
      inputs[index + 1].focus();
    } else {
      inputs[index].blur();
    }
  };

  const onchange = () => {
    const pin = inputs.map((i) => i.value).join("");
    inputPin.value = pin;
    console.log("onchange pin", pin);
  };

  inputs.forEach((input, index) => {
    const currentIndex = index;

    input.addEventListener("keydown", (e) => {
      if (/^\d$/.test(e.key)) {
        e.preventDefault();
        input.value = e.key;
        onchange();
        selectNextInput(currentIndex);
      }
    });

    input.addEventListener("input", (e) => {
      const digit = e.target.value.replace(/\D/g, "").charAt(0);
      input.value = digit;
      onchange();
    });

    input.addEventListener("keydown", (e) => {
      if (e.key === "Backspace") {
        input.value = "";
        if (currentIndex > 0) {
          inputs[currentIndex - 1].focus();
        }
        onchange();
        e.preventDefault();
      } else if (e.key === "ArrowLeft" && currentIndex > 0) {
        inputs[currentIndex - 1].focus();
        e.preventDefault();
      } else if (e.key === "ArrowRight" && currentIndex < inputs.length - 1) {
        inputs[currentIndex + 1].focus();
        e.preventDefault();
      }
    });

    input.addEventListener("paste", (e) => {
      e.preventDefault();
      const pasted = (e.clipboardData.getData("text") ?? "")
        .replace(/\D/g, "") // supprime tout sauf [0-9]
        .slice(0, inputs.length); // ne garde que ce qu'on peut afficher

      pasted.split("").forEach((char, i) => {
        if (currentIndex + i < inputs.length) {
          inputs[currentIndex + i].value = char;
        }
      });

      onchange();
    });

    input.addEventListener("blur", onchange);
  });
};

const createInputPin = (attributes) => {};

const razorInputPin = {
  selector: ".a-inputpin",
  create: createInputPin,
  attach: attachInputPin,
};

export default razorInputPin;
